import AngleLeftIcon from "@/assets/icons/angle-left.svg?react";
import AngleRightIcon from "@/assets/icons/angle-right.svg?react";
import { HomeHeroBannerData } from "@/common/lib/types";
import { Carousel, Slide } from "@/components/ui/carousel/Carousel";
import { cn } from "@/lib/tailwind";
import SingleImageBanner from "./banners/SingleImageBanner";
import { VideoBanner } from "./banners/VideoBanner";

interface IProps {
  isDynamicHeaderShown?: boolean;
  heroBannerData?: HomeHeroBannerData;
}

const HeroBanner = ({ heroBannerData, isDynamicHeaderShown }: IProps) => {

  // methods
  const renderBanners = () => {
    const res: Slide[] = [];

    for (const item of heroBannerData?.items ?? []) {
      switch (item.mediaType) {
        case "video":
          res.push({
            slideClasses: "basis-full",
            content: (
              <VideoBanner
                desktopUrl={item.media.desktop}
                mobileUrl={item.media.mobile}
                link={item.link?.url ?? "/"}
                thumbnail={item.thumbnail}
              />
            ),
          } as Slide);
          break;

        case "image":
          res.push({
            slideClasses: "basis-full",
            content: (
              <SingleImageBanner
                type={item?.type}
                featuredProducts={item?.featuredProducts}
                image={item.media.desktop}
                mobileImage={item.media.mobile}
                ctaConfig={{
                  url: item.link?.url ?? "/",
                }}
                ctaSection={item?.ctaSection}

              />
            ),
          } as Slide);
          break;
      }
    }

    return res;
  };

  return (
    <section className={cn(isDynamicHeaderShown && "mt-[40px] md:mt-[50px]")}>
      <Carousel
        autoPlay={{
          stopOnMouseEnter: true,
          stopOnInteraction: false,
        }}
        carouselOptions={{
          loop: true,
        }}
        slides={renderBanners()}
        controls={heroBannerData && heroBannerData?.items?.length > 1 ? {
          left: {
            content: (
              <div className="pointer-events-auto flex size-[30px] items-center justify-center bg-white/50 text-black">
                <AngleLeftIcon className="!h-[10px] !w-[12px]" />
              </div>
            ),
          },
          right: {
            content: (
              <div className="pointer-events-auto flex size-[30px] items-center justify-center bg-white/50 text-black">
                <AngleRightIcon className="!h-[10px] !w-[12px]" />
              </div>
            ),
          },
        } : {}}
      />

      {/* {contents.some((item) => item.variant === "multiCta") && (
        <div className="flex flex-1 items-center justify-center bg-secondary-1 py-10 lg:hidden">
          <div className="px-4 md:block">
            <h2 className="mb-6 text-center text-2xl font-bold text-white">
              Enjoy 20% off these styles
            </h2>
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-3">
              {[1, 2, 3, 4, 5, 6].map((item, i) => (
                <Button key={i} variant={"text"} className="px-6 py-2">
                  Style Name
                </Button>
              ))}
            </div>
          </div>
        </div>
      )} */}
    </section>
  );
};

export default HeroBanner;
